export default __webpack_public_path__ + "static/media/insta.fac17bf8.png";